const Seperator = () => {
    return(
        <hr className="separator" />
    )
}

export default Seperator